/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ClassProvider, ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AUTH_OPTIONS } from './auth-options';
import { UserContext } from './user-context/user-context.service';
import { LoggedInUserService } from './user-context/logged-in-user.service';
import { EnvironmentModule } from '@irian-ro/util-environment';
import { LOGGED_IN_CONTEXT_SERVICE } from './user-context/logged-in-context.config';

export const LOGGED_IN_USER_PROVIDER: ClassProvider = {
  provide: LOGGED_IN_CONTEXT_SERVICE,
  useClass: LoggedInUserService,
};

@NgModule({
  imports: [CommonModule, EnvironmentModule],
})
export class UserManagementModule {
  static forRoot(
    options = { storage: 'local-storage' },
    loggedInContextProvider: Provider = LOGGED_IN_USER_PROVIDER
  ): ModuleWithProviders<UserManagementModule> {
    return {
      ngModule: UserManagementModule,
      providers: [{ provide: AUTH_OPTIONS, useValue: options }, UserContext, loggedInContextProvider],
    };
  }
}
